// Centralized configuration for PDPReport
const pdpReportConfig = {
  reportKey: "pdp_report_column_visibility",

  tableTemplate: [
    { field: "employeeid",             headerName: "Employee ID" },
    { field: "employeename",           headerName: "Employee Name" },
    { field: "grade",                  headerName: "Grade" },
    { field: "primaryskill",           headerName: "Primary Skill" },
    { field: "secondaryskill",         headerName: "Secondary Skill" },
    { field: "sef",                    headerName: "SEF" },
    { field: "location",               headerName: "Location" },
    { field: "region",                 headerName: "Region" },
    { field: "mapped_so",              headerName: "Mapped SO" },
    { field: "so_mapping_date",        headerName: "SO Mapping Date" },
    { field: "projectid",              headerName: "Project ID" },
    { field: "projectname",            headerName: "Project Name" },
    { field: "allocationstartdate",    headerName: "Allocation Start Date" },
    { field: "allocationenddate",      headerName: "Allocation End Date" },
    { field: "vertical",               headerName: "Vertical" },
    { field: "practice",               headerName: "Practice" },
    { field: "departmentname",         headerName: "Department" },
    { field: "releasingprojectid",     headerName: "Releasing Project ID" },
    { field: "releasingprojectname",   headerName: "Releasing Project Name" },
    { field: "releasingaccountname",   headerName: "Releasing Account Name" },
    { field: "releasingmarketunit",    headerName: "Releasing Market Unit" },
    { field: "hackersrankscore",       headerName: "Hacker Rank Score" },
    { field: "releasingbusinessunit",  headerName: "Releasing Business Unit" },
    { field: "releasingprojectpmid",   headerName: "Releasing Project PM ID" },
    { field: "action",                 headerName: "Action" },
    { field: "proposedbu",             headerName: "Proposed BU" },
    { field: "pdptranid",              headerName: "PDP Tran ID" },
    { field: "comments",               headerName: "Comments" },
    { field: "actiondate",             headerName: "Action Date" },
    { field: "prioritybilling",        headerName: "Priority Billing" },
    { field: "previouscomments",       headerName: "Previous Comments" },
    { field: "constraints",            headerName: "Constraints" },
    { field: "visibility",             headerName: "Visibility" },
    { field: "hr_status",              headerName: "HR Status" },
    { field: "benchageing",            headerName: "Bench Ageing" },
    { field: "ageingbucket",           headerName: "Ageing Bucket" },
    { field: "last_updated_date",      headerName: "Last Updated Date" },
    { field: "report_extraction_date", headerName: "Report Extraction Date" }
  ],

  filterTemplate: [
    { field: "primaryskill",   headerName: "Primary Skill" },
    { field: "grade",          headerName: "Grade" },
    { field: "region",         headerName: "Region" },
    { field: "location",       headerName: "Location" },
    { field: "practice",       headerName: "Practice" },
    { field: "departmentname", headerName: "Department" },
    { field: "proposedbu",     headerName: "Proposed BU" },
    { field: "action",         headerName: "Action" }
  ]
};

export default pdpReportConfig;
